<template>
  <div class="step-conteudo">
    <div class="section-label">Conteúdo do artigo</div>
    <p class="step-conteudo__hint">
      Além do texto, o editor aceita imagem e vídeo incorporado em qualquer tipo
      de artigo.
    </p>
    <EditorConteudo :item="item" />
    <div v-if="validacao.firstError('item.conteudo')" class="message">
      {{ validacao.firstError("item.conteudo") }}
    </div>
  </div>
</template>

<script>
import EditorConteudo from "@/components/EditorConteudo.vue";

export default {
  name: "StepConteudo",
  components: { EditorConteudo },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.section-label {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #344054;
  letter-spacing: 0.3px;
  background: #f2f4f7;
  border-left: 3px solid #3a3e81;
  padding: 6px 10px;
  margin-bottom: 8px;
}

.step-conteudo__hint {
  font-size: 11px;
  color: #98a2b3;
  margin: 0 0 8px;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 6px;
}
</style>
